import {
  zigzagSchema2,
  zigzag2
} from "./index-afdtmrh2.mjs";
export {
  zigzag2 as zigzag,
  zigzagSchema2 as zigzagSchema
};
